export default class Paystub {
  /**
   * @type {number}
  */
  id = undefined;

  /**
   * @type {number}
  */
  clientId = undefined;

  /**
   * @type {number}
  */
  medicareTax = undefined;

  /**
   * @type {number}
  */
  federalTax = undefined;

  /**
   * @type {number}
  */
  retirementAmt = 0.00;

  /**
   * @type {string}
  */
  state = 'SC';

  /**
   * @type {number}
  */
  stateTax = undefined;

  /**
   * @type {string}
  */
  paystubDate = undefined;

  /**
   * @type {string}
  */
  dateAdded = undefined;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.medicareTax != null) {
        this.medicareTax = opts.medicareTax;
      }
      if (opts.federalTax != null) {
        this.federalTax = opts.federalTax;
      }
      if (opts.retirementAmt != null) {
        this.retirementAmt = opts.retirementAmt;
      }
      if (opts.state != null) {
        this.state = opts.state;
      }
      if (opts.stateTax != null) {
        this.stateTax = opts.stateTax;
      }
      if (opts.paystubDate != null) {
        this.paystubDate = opts.paystubDate;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
    }
  }
}
